// services/SchoolPassService.js
import http from "../http-common";

class SchoolPassService {
  // Создание пропуска
  createSchoolPass(data) {
    return http.post(`/sp_createSchoolPass`, data);
  }

  // Получение пропусков по массиву userID
  getPassesByUserIDs(data) {
    return http.post(`/sp_getPassesByUserIDs`, {
      userIds: data.userIds,
    });
  }

  // Получение одного пропуска по ID
  getPassByID(data) {
    return http.get(`/sp_getPassByID/${data.id}`);
  }

  // Удаление пропуска по ID
  deletePassByID(data) {
    return http.delete(`/sp_deletePassByID/${data.id}`);
  }
}

export default new SchoolPassService();
